import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { MenuPageRoutingModule } from './menu-routing.module';

import { MenuPage } from './menu.page';
import { CartComponent } from '../menu/components/cart/cart.component';
import { CategoryNavComponent } from '../menu/components/category-nav/category-nav.component';
import { HeaderPageModule } from '../header/header.module';
import { PipesModule } from 'src/app/shared/pipe/pipe.module';
import { MenuListPageModule } from './components/menu-list/menu-list.module';
import { TranslateModule } from '@ngx-translate/core';
import { NotFoundPageModule } from '../notFound/not-found.module';
import { ShowRecommendedProductsPageModule } from './components/show-recommended-products/show-recommended-products.module';
import { SharedModule } from './shared.module';
import { RemovedItemsDialogPageModule } from './components/removed-items-dialog/removed-items-dialog.module';
import { SearchModalModule } from './components/search-modal/search-modal.module';
import { MpFloatingLabelComponent } from 'src/app/shared/components/mp-floating-label/mp-floating-label.component';

/**
 * NÃO importe aqui os módulos das telas de PRODUTO (`ExtraPageModule`, `PizzaPageModule`,
 * `AdditionalToppingsPageModule` das duas pizzas). Elas são rotas lazy no `app-routing`
 * (`extra`, `pizza`, `pizza-nep`), abertas quando a pessoa TOCA num produto — mas o import
 * estático vence o `loadChildren`, e o webpack copiava as três para dentro do `main.js` do
 * boot: ~270 KB de fonte que toda visita baixava antes de ver o cardápio (medido em
 * 17/09/2026). Nenhuma delas exporta componente algum, então o template do menu nunca
 * precisou desses imports — eram peso puro. O `check:lazy-nao-vaza` reprova a volta disso.
 */
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		CommonModule,
		FormsModule,
		MenuPageRoutingModule,
		SharedModule,
		HeaderPageModule,
		PipesModule,
		MenuListPageModule,
		TranslateModule,
		NotFoundPageModule,
		ShowRecommendedProductsPageModule,
		RemovedItemsDialogPageModule,
		SearchModalModule,
		MpFloatingLabelComponent,
	],
	declarations: [
		MenuPage,
	],})
export class MenuPageModule { }
